/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StockAndOfferDto } from '../models/StockAndOfferDto';
import type { WebSiteModelDto } from '../models/WebSiteModelDto';
import type { WebSiteUrlDateLogInput } from '../models/WebSiteUrlDateLogInput';
import type { WebSiteUrlDto } from '../models/WebSiteUrlDto';
import type { WebSiteUrlDtoPagedListData } from '../models/WebSiteUrlDtoPagedListData';
import type { WebSiteUrlParameterDto } from '../models/WebSiteUrlParameterDto';
import type { WebSiteUrlParameterDtoPagedListData } from '../models/WebSiteUrlParameterDtoPagedListData';
import type { WebSiteUrlParameterInput } from '../models/WebSiteUrlParameterInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WebSiteUrlService {

  /**
   * @returns WebSiteUrlDto Success
   * @throws ApiError
   */
  public static getWebSiteUrlGetUrlData(): CancelablePromise<Array<WebSiteUrlDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebSiteUrl/GetUrlData',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param url 
   * @returns WebSiteUrlDto Success
   * @throws ApiError
   */
  public static getWebSiteUrlGetUrlDataByUrl(
url?: string,
): CancelablePromise<WebSiteUrlDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebSiteUrl/GetUrlDataByUrl',
      query: {
        'url': url,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns StockAndOfferDto Success
   * @throws ApiError
   */
  public static getWebSiteUrlGetStockAndOfferIds(): CancelablePromise<StockAndOfferDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebSiteUrl/GetStockAndOfferIds',
    });
  }

  /**
   * @param pageName 
   * @param pageUrl 
   * @param modelId 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns WebSiteUrlDtoPagedListData Success
   * @throws ApiError
   */
  public static getWebsiteUrlLogs(
pageName?: string,
pageUrl?: string,
modelId?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<WebSiteUrlDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/website-url-logs',
      query: {
        'PageName': pageName,
        'PageUrl': pageUrl,
        'ModelId': modelId,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postWebsiteUrlLogs(
requestBody?: WebSiteUrlDateLogInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/website-url-logs',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WebSiteUrlDto Success
   * @throws ApiError
   */
  public static getWebsiteUrlLogs1(
id: number,
): CancelablePromise<WebSiteUrlDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/website-url-logs/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putWebsiteUrlLogs(
id: number,
requestBody?: WebSiteUrlDateLogInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/website-url-logs/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteWebsiteUrlLogs(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/website-url-logs/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param parameterName 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns WebSiteUrlParameterDtoPagedListData Success
   * @throws ApiError
   */
  public static getWebsiteUrlLogsParameter(
parameterName?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<WebSiteUrlParameterDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/website-url-logs/parameter',
      query: {
        'ParameterName': parameterName,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postWebsiteUrlLogsParameter(
requestBody?: WebSiteUrlParameterInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/website-url-logs/parameter',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WebSiteUrlParameterDto Success
   * @throws ApiError
   */
  public static getWebsiteUrlLogsParameter1(
id: number,
): CancelablePromise<WebSiteUrlParameterDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/website-url-logs/parameter/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putWebsiteUrlLogsParameter(
id: number,
requestBody?: WebSiteUrlParameterInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/website-url-logs/parameter/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteWebsiteUrlLogsParameter(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/website-url-logs/parameter/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns WebSiteModelDto Success
   * @throws ApiError
   */
  public static getWebsiteUrlLogsModels(): CancelablePromise<Array<WebSiteModelDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/website-url-logs/models',
      errors: {
        404: `Not Found`,
      },
    });
  }

}
